import { React } from 'react';
import {
  Typography, Image,
} from 'antd';
import { useMediaQuery } from 'react-responsive';

// import SaveSeagullIcon from '../../components/icons/SaveSeagull';

// import buoyImage from '../../assets/buoy-photo.jpg';
// import lakeshoreImage from '../../assets/lakeshore.jpg';
// import seagullMegaphone from '../../assets/seagull-megaphone.svg';
import WaveDivider from '../../components/icons/WaveDivider';
import { brandingConfig } from '../../config';
import DonorBox from './donor-box';
import donorCloudImage from '../../assets/Support.png';
import BulletItem from './bullet-item';
import laptopImage from '../../assets/maclaptop.png';
import yetiBoxImage from '../../assets/yetibox.jpg';
import bouyImage from '../../assets/bouy.png';
import seagullSpeakerImage from '../../assets/seagullspeaker.svg';

const SupportSeagull = () => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const isDesktop = useMediaQuery({ minWidth: 1024 });
  // const donateRef = useRef(null);

  // const scrollToDonate = () => {
  //   if (isDesktop) {
  //     const container = document.querySelector('.ant-layout-content');
  //     container?.scrollTo({ top: 0, behavior: 'smooth' });
  //   } else {
  //     donateRef.current?.scrollIntoView({ behavior: 'smooth' });
  //   }
  // };

  const tierStyle = {
    color: 'white',
    fontSize: 16,
    marginTop: 5,
    fontWeight: 600,
    marginBottom: 0,
  };

  const tierStyleSubTitle = {
    color: 'white',
    fontSize: 20,
    marginTop: 5,
    fontWeight: 600,
    marginBottom: 0,
  };

  const fundLinkStyle = {
    color: '#75c6ffff',
    fontWeight: 'bold',
  };

  return (
    <div>
      <div
        style={{
          // backgroundImage: `url(${buoyImage})`,
          background: 'linear-gradient(to bottom, #0D4C71, #03304B)',
          padding: `${isMobile ? '20px' : '120px'} 20px 125px 20px`,
        }}
      >
        <div
          style={{
            maxWidth: 1500,
            margin: '0 auto',
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            alignItems: 'flex-start',
            gap: 0,
          }}
        >
          {/* LEFT COLUMN – IMAGE */}
          <div
            style={{
              flex: '0 0 50%',
              textAlign: 'center',
              paddingTop: '30px',
              paddingLeft: '30px',
              paddingRight: '30px',
              height: 'auto',
            }}
          >
            <Image
              src={donorCloudImage}
              preview={false}
              alt="Seagull"
              style={{
                width: '100%',
              }}
            />
          </div>

          {/* RIGHT COLUMN – TEXT */}
          <div
            style={{
              flex: '0 0 50%',
              padding: '10px',
            }}
          >
            <div
              style={{
                maxWidth: 640,
                margin: '0 auto',
              }}
            >
              <Typography.Title
                level={1}
                style={
                  {
                    color: 'white',
                    marginTop: 20,
                    fontSize: 38,
                    textAlign: 'center',
                  }
                }
              >
                Support GLOS and Keep Seagull Soaring!
              </Typography.Title>
              <Typography.Paragraph style={{ color: 'white', fontSize: 20 }}>
                A donation to the
                <a style={fundLinkStyle} href="https://glos.org"> Great Lakes Observing System (GLOS) </a>
                helps strengthen the science, technology, and tools that help everyone stay safe and informed across the Great Lakes.
              </Typography.Paragraph>
              <Typography.Paragraph style={{ color: 'white', fontSize: 20 }}>
                GLOS powers trusted services like Seagull - your trusty, free-to-use wingbird. YOUR SUPPORT helps keep our feathers fluffed, our communities informed, and our lakes a little safer for all by helping deliver real-time weather and marine updates. By donating to GLOS, you’re helping the entire system thrive - while snagging some squawk-tastic perks!
              </Typography.Paragraph>
            </div>
          </div>
        </div>
      </div>

      <div
        style={{
          marginTop: isDesktop ? -25 : -15,
        }}
      >
        <WaveDivider />
      </div>

      <div
        id="donate"
        style={{
          // backgroundImage: `url(${buoyImage})`,
          background: '#0D4C71',
          padding: '40px 20px 125px 20px',
        }}
      >
        <div
          style={{
            maxWidth: 1500,
            margin: '0 auto',
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            gap: 0,
          }}
        >
          {/* LEFT COLUMN – DONATE */}
          <div
            style={{
              flex: '0 0 50%',
              textAlign: 'center',
              alignItems: 'center',
              padding: '0px',
            }}
          >
            <DonorBox />
          </div>

          {/* RIGHT COLUMN – TEXT */}
          <div
            style={{
              flex: '0 0 50%',
              padding: '10px',
              paddingTop: '0px',
            }}
          >
            <div
              style={{
                maxWidth: 640,
                margin: '0 auto',
              }}
            >
              <Typography.Title
                level={1}
                style={{ color: 'white', marginTop: 20, fontSize: 32 }}
              >
                Pick Your Perch
              </Typography.Title>

              <span style={{ marginTop: 5 }}>
                <Typography.Text style={tierStyleSubTitle}>
                  Suggested levels of support:
                </Typography.Text>
              </span>
              <br />
              <br />
              <span style={{ marginTop: 5 }}>
                <Typography.Text style={tierStyle}>
                  Squawk Squad ($5/month or $50/year):
                </Typography.Text>
              </span>
              <BulletItem>
                <span style={{ fontStyle: 'normal' }}>Seasonal Giveaways:</span>
                {' '}
                1 entry into our seasonal raffle for a chance to win lake-inspired swag or weather/marine gear.
              </BulletItem>

              <div style={{ marginTop: 8 }}>
                <Typography.Text style={tierStyle}>
                  Wave Watcher ($10/month or $100/year):
                </Typography.Text>
              </div>
              <BulletItem>
                <span style={{ fontStyle: 'normal' }}>Seasonal Giveaways:</span>
                {' '}
                2 entries into the raffle for a better shot at grabbing the goodies
              </BulletItem>

              <div style={{ marginTop: 8 }}>
                <Typography.Text style={tierStyle}>
                  Coast Keeper ($25/month or $250/year):
                </Typography.Text>
              </div>
              <BulletItem>
                <span style={{ fontStyle: 'normal' }}>Seasonal Giveaways:</span>
                {' '}
                3 entries into the seasonal raffle for an increased chance to win.
              </BulletItem>
              <BulletItem>
                <span style={{ fontStyle: 'normal' }}>Early Access:</span>
                {' '}
                Be the first to test new Seagull features before they take flight for all us
              </BulletItem>

              <div style={{ marginTop: 8 }}>
                <Typography.Text style={tierStyle}>
                  Wing Warden ($50/month or $500/year):
                </Typography.Text>
              </div>
              <BulletItem>
                <span style={{ fontStyle: 'normal' }}>Seasonal Giveaways:</span>
                {' '}
                4 entries into the raffle for a strong chance to win awesome prizes.
              </BulletItem>
              <BulletItem>
                <span style={{ fontStyle: 'normal' }}>Beta Bird Testing:</span>
                {' '}
                Get exclusive access to test new Seagull versions and share your squawks to shape the app.
              </BulletItem>

              <div style={{ marginTop: 8 }}>
                <Typography.Text style={tierStyle}>
                  Sky Skipper ($100/month or $1000/year):
                </Typography.Text>
              </div>
              <BulletItem>
                <span style={{ fontStyle: 'normal' }}>Seasonal Giveaways:</span>
                {' '}
                6 entries into the raffle for the best chance to win.
              </BulletItem>
              <BulletItem>
                Complimentary invitations to GLOS/Seagull events + Special recognition for your support.
              </BulletItem>
              <BulletItem>
                <span style={{ fontStyle: 'normal' }}>Feature Feathers:</span>
                {' '}
                Suggest ideas for future app updates, helping us feather our nest with new features.
              </BulletItem>
              <br />
            </div>
          </div>
        </div>

      </div>

      <div
        style={{
          background: '#03304B',
          padding: '0px 20px 50px 20px',
        }}
      >
        <div
          style={{
            maxWidth: 1200,
            margin: '0 auto',
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            alignItems: 'flex-start',
            gap: 0,
          }}
        >
          {/* LEFT COLUMN – TEXT */}
          <div
            style={{
              flex: '0 0 40%',
              padding: '10px',
              paddingTop: `${isMobile ? '10px' : '70px'}`,
              order: isMobile ? 2 : 1,
            }}
          >
            <div
              style={{
                maxWidth: 640,
                margin: '0 auto',
              }}
            >
              <Typography.Title
                level={1}
                style={{ color: 'white', marginTop: 20, fontSize: 32 }}
              >
                Feature Your Business
              </Typography.Title>

              <Typography.Paragraph style={{ color: 'white', fontSize: 16 }}>
                Join as a
                {' '}
                <span style={{ fontWeight: 'bold' }}>featured Beacon Bird</span>
                {' '}
                and let your brand glow like a soaring bird lighting up the coasts in the Seagull app!
              </Typography.Paragraph>

              <Typography.Text style={tierStyle}>
                Featured Beacon Bird:
              </Typography.Text>
              <BulletItem>
                <span style={{ fontStyle: 'normal' }}>Flock Fame:</span>
                {' '}
                Your business’s logo, name and details will be prominently displayed in the Seagull app. These beacons are visible to thousands of users everyday.
              </BulletItem>
              <BulletItem>
                <span style={{ fontStyle: 'normal' }}>Wing-Worthy Mentions:</span>
                {' '}
                Get highlighted in app updates and on our website as a key flock supporter.
              </BulletItem>

              <Typography.Text
                style={{
                  color: 'white',
                  paddingTop: 10,
                  fontSize: 16,
                  paddingBottom: 10,
                  display: 'block', // this makes paddingTop work
                }}
              >
                Perfect for:
              </Typography.Text>
              <BulletItem>
                Marinas
              </BulletItem>
              <BulletItem>
                Kayak & paddleboard rentals
              </BulletItem>
              <BulletItem>
                Bait & tackle shops
              </BulletItem>
              <BulletItem>
                Lakeside restaurants
              </BulletItem>
              <BulletItem>
                Environmental organizations
              </BulletItem>
              <Typography.Text
                style={{
                  color: 'white',
                  paddingTop: 10,
                  fontSize: 16,
                  display: 'block', // this makes paddingTop work
                }}
              >
                Interested? Contact us for pricing details.
              </Typography.Text>
              <div
                style={{
                  display: 'flex',
                  gap: 16,
                  marginTop: 20,
                  flexWrap: 'wrap',
                  justifyContent: `${isMobile ? 'center' : 'flex-start'}`,
                }}
              >
                <Typography.Link
                  href="https://glos.org/priorities/seagull/#contact_forms"
                  target="_blank"
                  style={{
                    color: 'white',
                    background: brandingConfig.colors.accent1,
                    border: `1px solid ${brandingConfig.colors.accent1}`,
                    fontSize: 16,
                    borderRadius: 99,
                    padding: '7px 20px',
                    lineHeight: 1.4,
                    height: 'auto',
                  }}
                >
                  Contact Seagull
                </Typography.Link>
              </div>
            </div>
          </div>

          {/* RIGHT COLUMN – IMAGE */}
          <div
            style={{
              flex: '0 0 60%',
              textAlign: 'center',
              padding: '10px',
              order: isMobile ? 1 : 2,
            }}
          >
            <Image
              src={laptopImage}
              preview={false}
              alt="Laptop"
              style={{
                width: '105%',
                paddingTop: `${isMobile ? '10px' : '100px'}`,
                flex: '0 0 50%',
              }}
            />
          </div>

        </div>
      </div>

      <div
        style={{
          background: '#0D4C71',
          padding: '0px 00px 50px 20px',
        }}
      >
        <div
          style={{
            maxWidth: 1400,
            margin: '0 auto',
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            alignItems: 'center',
            gap: 0,
          }}
        >
          {/* LEFT COLUMN – IMAGE */}
          <div
            style={{
              flex: '0 50%',
              textAlign: 'center',
              padding: '10px',
            }}
          >
            <Image
              src={yetiBoxImage}
              preview={false}
              alt="Laptop"
              style={{
                paddingRight: `${isMobile ? '15px' : '10px'}`,
                paddingTop: `${isMobile ? '20px' : '60px'}`,
                flex: '0 0 50%',
              }}
            />
          </div>

          {/* RIGHT COLUMN – TEXT */}
          <div
            style={{
              flex: '0 0 50%',
              padding: '10px',
              paddingTop: `${isMobile ? '0px' : '70px'}`,
            }}
          >
            <div
              style={{
                maxWidth: 640,
                margin: '0 auto',
              }}
            >
              <Typography.Title
                level={1}
                style={{ color: 'white', marginTop: 20, fontSize: 32 }}
              >
                Seasonal Giveaways: Squawk for Swag!
              </Typography.Title>

              <Typography.Paragraph style={{ color: 'white', fontSize: 16 }}>
                Every donor gets a shot at our quarterly giveaway for a free weather/marine gear. Higher tiers mean more entries, so spread your wings and join the flock today!
              </Typography.Paragraph>

              <BulletItem>
                <span style={{ fontWeight: 'bold' }}>Squawk Squad:</span>
                {' '}
                1 entry
              </BulletItem>
              <BulletItem>
                <span style={{ fontWeight: 'bold' }}>Wave Watcher:</span>
                {' '}
                2 entries
              </BulletItem>
              <BulletItem>
                <span style={{ fontWeight: 'bold' }}>Coast Keeper:</span>
                {' '}
                3 entries
              </BulletItem>
              <BulletItem>
                <span style={{ fontWeight: 'bold' }}>Wing Warden:</span>
                {' '}
                4 entries
              </BulletItem>
              <BulletItem>
                <span style={{ fontWeight: 'bold' }}>Sky Skipper:</span>
                {' '}
                6 entries
              </BulletItem>

            </div>
          </div>

        </div>
      </div>

      <div
        style={{
          background: '#D9F3FF',
          padding: '0px 20px 40px 20px',
        }}
      >
        <div
          style={{
            maxWidth: 1500,
            margin: '0 auto',
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            alignItems: 'center',
            gap: 0,
          }}
        >
          {/* RIGHT COLUMN – TEXT */}
          <div
            style={{
              flex: '0 0 70%',
              padding: '10px',
              paddingTop: `${isMobile ? '10px' : '70px'}`,
              paddingRight: `${isMobile ? '0px' : '90px'}`,
            }}
          >
            <div
              style={{
                margin: '0 auto',

              }}
            >
              <Typography.Title
                level={1}
                style={{ color: '#031A3B', marginTop: 20, fontSize: 32 }}
              >
                Why This Matters
              </Typography.Title>

              <Typography.Paragraph style={{ color: '#031A3B', fontSize: 16 }}>
                Through Seagull, GLOS delivers critical weather and marine data to keep drinking water safe; guide boaters, surfers, fishers, and swimmers; prevent drownings; and steer lake freighters clear of stormy waters.
              </Typography.Paragraph>
              <Typography.Paragraph style={{ color: '#031A3B', fontSize: 16 }}>
                To many, this is a lifeline. So, we believe everyone deserves this information for free!
              </Typography.Paragraph>
              <Typography.Paragraph style={{ color: '#031A3B', fontSize: 16 }}>
                But without government funding, our wings are clipped. If the Great Lakes Observing System (GLOS) loses its wind, Seagull access could cease. Your donations give GLOS the support to advance our mission. Join the flock and let’s keep ‘making waves’ together!
              </Typography.Paragraph>

            </div>
          </div>

          {/* LEFT COLUMN – IMAGE */}
          <div
            style={{
              flex: '0 0 30%',
              textAlign: 'center',
              padding: '0px',
            }}
          >
            <Image
              src={bouyImage}
              preview={false}
              alt="Laptop"
              style={{
                maxWidth: 375,
                paddingTop: `${isMobile ? '10px' : '40px'}`,
                flex: '0 0 50%',
              }}
            />
          </div>

        </div>
      </div>

      <div
        style={{
          background: '#03304B',
          padding: '0px 20px 0px 20px',
        }}
      >
        <div
          style={{
            maxWidth: 1500,
            margin: '0 auto',
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            alignItems: 'flex-start',
            gap: 0,
          }}
        >
          {/* LEFT COLUMN – IMAGE */}
          <div
            style={{
              flex: '0 0 30%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-end',
              alignItems: 'center', // this works for both directions
              width: '100%', // <-- make sure this container spans full width when stacked
              order: isMobile ? 2 : 1,
            }}
          >
            <Image
              src={seagullSpeakerImage}
              preview={false}
              alt="Seagull"
              style={{
                maxWidth: 250,
                paddingTop: isMobile ? '20px' : '100px',
                flex: '0 0 auto',
                margin: '0 auto', // <-- absolutely forces horizontal centering regardless of parent
              }}
            />
          </div>

          {/* RIGHT COLUMN – TEXT */}
          <div
            style={{
              flex: '0 0 70%',
              padding: '10px',
              paddingTop: `${isMobile ? '10px' : '60px'}`,
              paddingRight: `${isMobile ? '00px' : '50px'}`,
              order: isMobile ? 1 : 2,
            }}
          >
            <div
              style={{

                margin: '0 auto',
              }}
            >
              <Typography.Title
                level={1}
                style={{ color: 'white', marginTop: 20, fontSize: 32 }}
              >
                Your Voice Matters
              </Typography.Title>

              <Typography.Paragraph style={{ color: 'white', fontSize: 16 }}>
                Has
                {' '}
                <span style={{ fontStyle: 'normal' }}>Seagull</span>
                {' '}
                been your trusty co-pilot on the water or your weather-whisperer on shore? Squawk about it! Your support—whether it’s a donation, a shout-out, or a hearty “caw-caw” on social media—helps us keep our flock flying strong. By spreading the word, you’re helping
                {' '}
                <span style={{ fontStyle: 'normal' }}>Seagull</span>
                {' '}
                reach millions across the Great Lakes, keeping them safe and informed. So, flap your wings, share your story, and let’s make sure
                {' '}
                <span style={{ fontStyle: 'normal' }}>Seagull</span>
                {' '}
                soars to every corner of the coast!
              </Typography.Paragraph>

              <Typography.Paragraph style={{ color: 'white', fontSize: 16 }}>
                No matter how big or small, every donation helps
                {' '}
                <span style={{ fontStyle: 'normal' }}>Seagull</span>
                {' '}
                soar. Let’s keep the skies clear and the seas navigable together!
              </Typography.Paragraph>
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: isMobile ? 'repeat(2, auto)' : 'repeat(auto-fit, minmax(180px, auto))',
                  gridTemplateRows: isMobile ? 'auto auto' : 'auto',
                  gridAutoFlow: isMobile ? 'row' : 'initial',
                  justifyItems: isMobile ? 'center' : 'flex-start',
                  gap: 44,
                  marginTop: 20,
                  marginBottom: 20,
                }}
              >
                {/* COLUMN 1 */}
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      marginTop: 16,
                    }}
                  >
                    <Typography.Link
                      onClick={() => {
                        const el = document.getElementById('donate');
                        if (el) {
                          el.scrollIntoView({ behavior: 'smooth' });
                        }
                      }}
                      style={{
                        color: 'white',
                        background: brandingConfig.colors.accent1,
                        border: `1px solid ${brandingConfig.colors.accent1}`,
                        fontSize: 16,
                        borderRadius: 99,
                        height: 32,
                        width: 110,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '0 16px', // horizontal only
                        lineHeight: 1, // cleaner baseline
                        textDecoration: 'none',
                      }}
                    >
                      Donate
                    </Typography.Link>
                  </div>
                </div>

                {/* COLUMN 2 */}
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      marginTop: 16,
                    }}
                  >
                    <Typography.Link
                      href="https://glos.org/priorities/seagull/#contact_forms"
                      target="_blank"
                      style={{
                        color: 'white',
                        background: brandingConfig.colors.accent1,
                        border: `1px solid ${brandingConfig.colors.accent1}`,
                        fontSize: 16,
                        borderRadius: 99,
                        height: 32,
                        width: 130,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '0 16px', // horizontal only
                        lineHeight: 1, // cleaner baseline
                        textDecoration: 'none',
                      }}
                    >
                      Contact Us
                    </Typography.Link>
                  </div>
                </div>

                {/* COLUMN 3 */}
                <div
                  style={{
                    gridColumn: isMobile ? '1 / span 2' : 'auto',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      marginTop: 16,
                      gap: 23,
                    }}
                  >
                    {/* Instagram */}
                    <a
                      href="https://www.instagram.com/greatlakesobservingsystem/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="GLOS Instagram"
                      style={{
                        backgroundColor: brandingConfig.colors.accent1,
                        borderRadius: '50%',
                        width: 32,
                        height: 32,
                        minWidth: 32,
                        minHeight: 32,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'white',
                        textDecoration: 'none',
                        flexShrink: 0,
                      }}
                    >
                      <i className="fab fa-instagram" />
                    </a>

                    {/* Facebook */}
                    <a
                      href="https://www.facebook.com/GreatLakesObservingSystem/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="GLOS Facebook"
                      style={{
                        backgroundColor: brandingConfig.colors.accent1,
                        borderRadius: '50%',
                        width: 32,
                        height: 32,
                        minWidth: 32,
                        minHeight: 32,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'white',
                        textDecoration: 'none',
                        flexShrink: 0,
                      }}
                    >
                      <i className="fab fa-facebook-f" />
                    </a>

                    {/* YouTube */}
                    <a
                      href="https://www.youtube.com/channel/UC9ru4SHsO7VHYNgQ5HNwyvg"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="GLOS YouTube"
                      style={{
                        backgroundColor: brandingConfig.colors.accent1,
                        borderRadius: '50%',
                        width: 32,
                        height: 32,
                        minWidth: 32,
                        minHeight: 32,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'white',
                        textDecoration: 'none',
                        flexShrink: 0,
                      }}
                    >
                      <i className="fab fa-youtube" />
                    </a>

                    {/* X (Twitter) */}
                    <a
                      href="https://twitter.com/RealGLOS"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="GLOS X (Twitter)"
                      style={{
                        backgroundColor: brandingConfig.colors.accent1,
                        borderRadius: '50%',
                        width: 32,
                        height: 32,
                        minWidth: 32,
                        minHeight: 32,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'white',
                        textDecoration: 'none',
                        flexShrink: 0,
                      }}
                    >
                      <i className="fab fa-x-twitter" />
                    </a>

                    {/* LinkedIn */}
                    <a
                      href="https://www.linkedin.com/company/great-lakes-observing-system/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="GLOS LinkedIn"
                      style={{
                        backgroundColor: brandingConfig.colors.accent1,
                        borderRadius: '50%',
                        width: 32,
                        height: 32,
                        minWidth: 32,
                        minHeight: 32,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'white',
                        textDecoration: 'none',
                        flexShrink: 0,
                      }}
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>

              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

SupportSeagull.propTypes = {
};

SupportSeagull.defaultProps = {
};

export default SupportSeagull;
